exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".success__page[data-v-55caf50f]{height:300px;display:flex;justify-content:center}.success__page a[data-v-55caf50f]{color:#2b2d34;font-weight:600}.success__page__contacts[data-v-55caf50f]{margin-top:auto}.cover-1[data-v-55caf50f]{min-height:30rem}", ""]);

// exports
